//error msg toggle
if ($("#MsgModal").length > 0) {
  if ($.trim($(".MsgModalFrontDiv").text())) {
    $("#MsgModal").modal("show");
    setTimeout(function () {
      $("#MsgModal").modal("hide");
    }, 5000);
  }
}

//select 2 change
$(".select2").select2();

if ($(".selectChangeDependency").length > 0) {
  $(".changefirst").on("change", function () {
    var curriculum_id = $(this).val();
    var that = $(this);
    $.ajax({
      url: themeurl + curriculum_id,
      success: function (data) {
        console.log(data);

        $(that).closest(".selectChangeDependency").find(".changesecond").html(data.html);
      }
    });
  });
}
//end select 2 change

//verfication
const inputElements = [...document.querySelectorAll("input.code-input")];

inputElements.forEach((ele, index) => {
  ele.addEventListener("keydown", e => {
    // if the keycode is backspace & the current field is empty
    // focus the input before the current. Then the event happens
    // which will clear the "before" input box.
    if (e.keyCode === 8 && e.target.value === "") inputElements[Math.max(0, index - 1)].focus();
  });
  ele.addEventListener("input", e => {
    // take the first character of the input
    // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
    // but I'm willing to overlook insane security code practices.
    const [first, ...rest] = e.target.value;
    e.target.value = first ?? ""; // first will be undefined when backspace was entered, so set the input to ""
    const lastInputBox = index === inputElements.length - 1;
    const didInsertContent = first !== undefined;
    if (didInsertContent && !lastInputBox) {
      // continue to input the rest of the string
      inputElements[index + 1].focus();
      inputElements[index + 1].value = rest.join("");
      inputElements[index + 1].dispatchEvent(new Event("input"));
    }
  });
});

// mini example on how to pull the data on submit of the form
function onSubmit(e) {
  e.preventDefault();
  const code = inputElements.map(({ value }) => value).join("");
  console.log(code);
}

//end verrivication
/*home page sliders*/
function rtl_slick() {
  if ($("body").hasClass("rtl")) {
    return true;
  } else {
    return false;
  }
}
$(".tutors-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  fade: true,
  autoplay: true,
  speed: 1000,
  rtl: rtl_slick(),

  autoplaySpeed: 2000,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        dots: true,
        arrows: false
      }
    }
  ]
});

$(".multiple-items:not(.lg-items):not(.med-items):not(.teachers-slider)").slick({
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 3,
  autoplay: true,
  autoplaySpeed: 2000,
  rtl: rtl_slick(),

  speed: 600,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 4,
        slidesToScroll: 3,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
});

$(".multiple-items.lg-items").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  // autoplay: true,
  autoplaySpeed: 2000,
  rtl: rtl_slick(),

  speed: 600,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

$(".vertical-items").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  verticalSwiping: false,

  vertical: true,
  verticalSwiping: true,
  speed: 600,
  dots: true,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        vertical: false,
        verticalSwiping: false,
        rtl: rtl_slick()
      }
    }
  ]
});
$(".multiple-items.med-items:not(.teachers-slider)").slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  // autoplay: true,
  autoplaySpeed: 2000,
  rtl: rtl_slick(),
  dots: true,

  speed: 600,

  speed: 1200,
  autoplay: true,
  autoplaySpeed: 2500,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
$(".multiple-items.teachers-slider").slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  // autoplay: true,
  autoplaySpeed: 2000,
  rtl: rtl_slick(),
  dots: true,

  speed: 600,

  speed: 1200,
  autoplay: true,
  autoplaySpeed: 2500,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(".two-items").slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  // autoplay: true,
  autoplaySpeed: 2000,
  rtl: rtl_slick(),
  dots: true,

  speed: 600,

  speed: 1200,
  autoplay: true,
  autoplaySpeed: 2500,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});






//

$(".multipleItemsNoautoPlay").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  rtl: rtl_slick(),
  dots: false,
  arrows:true,
  infinite: false,

  speed: 600,

  speed: 1200,
  autoplaySpeed: 2500,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

//
$("form").each(function () {
  $(this).validate({});
});

$(".more-items.slider").slick({
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 3,
  dots: true,
  arrows: false,
  // autoplay: true,
  // autoplaySpeed: 2000,
  rtl: rtl_slick(),

  speed: 600,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 4,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

$(".slider-w-arrows").slick({
  infinite: false,
  slidesToShow: 7,
  slidesToScroll: 3,
  dots: false,
  arrows: true,
  // autoplay: true,
  // autoplaySpeed: 2000,
  rtl: rtl_slick(),

  speed: 600,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 4,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
      }
    }
  ]
});

//for homeAfterLogin
$('.slide-show').slick({
  arrows: true, 
  dots: true,
  rtl: rtl_slick(),
  slidesToShow: 4,
  dots:true,
  // autoplay: true,

  speed: 600,
  dots: false,
  arrows: false,
  dots:true,

  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },

    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,

      }
    }
  ]

});
$('.blocks-slider').slick({
  arrows: true, 
  dots: true,
  rtl: rtl_slick(),
  slidesToShow: 5,
  dots:true,
  
  speed: 600,
  dots: false,
  arrows: false,
  dots:true,
  // autoplay: true,

  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },

    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,

      }
    }
  ]

});

//click to focus on input
$(".input-to-edit .click-to-edit").click(function () {
  $(this).parent(".input-to-edit").find("input").addClass("lolo").focus();
  $(this).parent(".input-to-edit").removeClass("disabled");
});

/*endhomepage slideres */
// Desktop Search
// $(document).ready(function() {
$(".search-ico").on("click", function (event) {
  $(".search-screen").addClass("open");
  $('.search-screen  input[type="search"]').focus();
});
$(".search-screen, .search-screen .close").on("click keyup", function (event) {
  if (event.target == this || $(this).hasClass("close") || event.keyCode == 27) {
    $(".search-screen").removeClass("open");
  }
});
// });

// end Desktop Search
//mobile menu
document.querySelectorAll(".js-nav-toggle").forEach(item => {
  item.addEventListener("click", event => {
    document.querySelector(".js-nav-toggle").classList.toggle("active");
    document.body.classList.toggle("offcanvas-visible");
    event.stopPropagation();
    return false;
  });
});

$("html").delegate("body.offcanvas-visible ,.menuclose", "click", function (e) {
  document.body.classList.toggle("offcanvas-visible");
  document.querySelector(".js-nav-toggle").classList.toggle("active");

  if (e.target.classList == "mobile-navigation" || $(e.target).parents(".mobile-navigation").length > 0) {
    // clicked menu content or children
  } else {
    document.querySelector(".mobile-navigation").classList.remove("show");
    document.querySelector(".js-nav-toggle").classList.remove("active");
    document.body.classList.remove("offcanvas-visible");
  }
});

//
$("#aaVideoModal").on("show.bs.modal", function (event) {
  var button = $(event.relatedTarget);
  var videosrc = button.data("video-src");
  // https://docs.videojs.com/tutorial-options.html
  let video_srt = `<video
                        id="my-video"
                        class="w-100 video-js"
                        controls
                        preload="auto"
                        autoplay="true"
                        poster=""
                        data-setup="{}">
                        <source src=${videosrc} type="video/mp4" />
                        </video>`;
  var modal = $(this);
  modal.find(".video-player").html(video_srt);
  videojs(document.querySelector(".video-js"));
});
$("#aaVideoModal").on("hidden.bs.modal", function (event) {
  var modal = $(this);
  modal.find(".video-player").html("");
});
//

$("#VideoModal").on("show.bs.modal", function (event) {
  var button = $(event.relatedTarget);
  var videosrc = button.data("video-src");
  var modal = $(this);
  if (button.data("video") == "mp4") {
    modal.find(".iframe-src").addClass("d-none");

    let video_srt = `<video
        id="my-video"
        class="w-100 video-js"
        controls
        preload="auto"
        autoplay="true"
        poster=""
        data-setup="{}">
        <source src=${videosrc} type="video/mp4" />
        </video>`;
    modal.find(".video-player").removeClass("d-none").html(video_srt);
    videojs(document.querySelector(".video-js"));
  } else {
    modal.find(".video-player").addClass("d-none");

    modal.find(".iframe-src").removeClass("d-none").find("iframe").attr("src", videosrc);
  }
});

$("#VideoModal").on("hide.bs.modal", function (event) {
  var modal = $(this);

  modal.find("iframe").attr("src", "");
  modal.find(".video-player").html("");
});

function checkclosemsg(event) {
  var targets = ".send-us-msg, .send-us-msg *";
  if (!event.target.matches(targets)) {
    $(".send-us-msg .collapse").collapse("hide");
  }
  var targets2 = ".cart-items-small *";
  if (!event.target.matches(targets2)) {
    $(".cart-items-small .items").removeClass("active");
  }
}
$("body").on("click", checkclosemsg);

$(".custom-control input:radio").change(function () {
  // Only remove the class in the specific `box` that contains the radio
  $(".custom-control.highlight").removeClass("highlight");
  $(this).closest(".custom-control").addClass("highlight");
});

//
$("body").delegate(".cart-items-small .cart-icon", "click", function () {
  $(".cart-items-small .items").toggleClass("active");
});

// $('[data-toggle="tooltip"]').tooltip();

//intro page

$(".intro-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  infinite: false,
  arrows: true,
  // fade: true,
  autoplay: true,
  speed: 1000,
  rtl: rtl_slick(),
  prevArrow: '<button class="slide-arrow prev-arrow"> السابق  <i class="fa fa-chevron-left ml-2"> </i> </button>',
  nextArrow: '<button class="slide-arrow next-arrow ml-2"> <i class="fa fa-chevron-right mr-2"> </i> التالي  </button>',
  autoplaySpeed: 2000,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        dots: true,
        arrows: false
      }
    }
  ]
});



//
$(".scrollTo").click(function() {
  let scrolledDiv=$(this).attr('to-scroll');
  console.log(scrolledDiv)
  $('html, body').animate({
      scrollTop: $("#"+scrolledDiv).offset().top-50
  }, 500);
});

$('.socialShare  .icon').click(function() {
   $(this).parent('.socialShare').find('.socialwrap').toggleClass('active')
})

$('.changeAccount  label').click(function(e) {
  $(this).parents().find('.option').removeClass('showTheForm');

  $(this).parent().closest('.option').addClass('showTheForm');


 
})




//coments eactions
$('#confirmDelete').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget) // Button that triggered the modal
  var recipient = button.data('id') // Extract info from data-* attributes
  // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
  // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
  var modal = $(this);
  if(modal.find('.confirm').attr('data-comment'))
  {

    modal.find('.confirm').attr('data-comment',recipient);
  }
  if(modal.find('.confirm').attr('data-id'))
  {

    modal.find('.confirm').attr('data-id',recipient);
  }

})


$('#confirmHide').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget) // Button that triggered the modal
  var recipient = button.data('id') // Extract info from data-* attributes
  // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
  // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
  var modal = $(this);
  modal.find('.confirm').attr('data-comment',recipient);
})



$("html").delegate(".edit-comment", "click", function (e) {
  $(this).addClass('deactivate');

  $(this).parent().find('.confirm-edit').addClass('activate');
  $(this).parent().closest('.comment-body').find('.textareToEdit').addClass('activate').focusin()
})






//


$('.paymentMethods  [type="radio"]').click(function () {
  $('.submitButton').addClass('active');
  var inputValue = $(this).attr("input");
  var targetBox = $("." + inputValue);
  $(".method-input").not(targetBox).hide(100);
  $(targetBox).show(200);
});



//landing
$('.why-us-carousel1').slick({
  infinite: true,
  variableWidth: true,
  slidesToShow: 1,
  swipe: true,
  arrows:true
  // swipeToSlide: true,
});

$('.why-us-carousel1').on('afterChange', function(event, slick, currentSlide, nextSlide){
console.log(currentSlide);
});


$(".why-us-carousel").slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  prevArrow: $('.arrows-nav .slick-prev'),
  nextArrow: $('.arrows-nav .slick-next'),
    rtl: rtl_slick(),

  speed: 600,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        speed: 300,

        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});




$(".quotes-carousel").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  // prevArrow: $('.arrows-nav .slick-prev'),
  // nextArrow: $('.arrows-nav .slick-next'),
    rtl: rtl_slick(),
    arrows:true,

  speed: 600})